export default "__VITE_ASSET__CtnDbqGL__"